module.exports = __webpack_public_path__ + "static/build_mockups-383be2b72af2368bea34fe87000e94c9.svg";